const SET_NYSERDA_IS_VISIBLE = 'SET_NYSERDA_IS_VISIBLE';

export { SET_NYSERDA_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/NYSERDA/constants.js